import { ServicesDetails } from 'components/services/service-details';

export const ServicesDetailsPage = () => {
  return <ServicesDetails />;
};

export default ServicesDetailsPage;
